import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDUserGroups_Form_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDUserGroups_Form_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  SaveRecord_1: number;
  SaveRecord_1_dummy: number;
  GoBack: any;
  GoBack_dummy: any;
  SelectSTDUserGroups: any[];
  SelectSTDUserGroups_dummy: any[];
  GetGroupDetail: any[];
  GetGroupDetail_dummy: any[];
  STDGetAllUserGroupsById: any[];
  STDGetAllUserGroupsById_dummy: any[];
}

export class STDUserGroups_Form_ScreenBase extends React.PureComponent<
  ISTDUserGroups_Form_ScreenProps,
  any
> {
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "a51ceefe-062e-4a2a-bef0-100b9df6880f",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 9544, PropertyName: "label", Value: "Kaydet" },
        { Id: 696180, PropertyName: "value", Value: "Kullanıcı Grubu Ekle" },
        { Id: 600208, PropertyName: "value", Value: "Kullanıcı Grubu" },
        { Id: 156069, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 869518, PropertyName: "value", Value: "Açıklama" },
        { Id: 109350, PropertyName: "placeholder", Value: "Type here..." },
        {
          Id: 269442,
          PropertyName: "value",
          Value: "Kullanıcı Grubu Yetkilendirme",
        },
        { Id: 662671, PropertyName: "value", Value: "View" },
        { Id: 604806, PropertyName: "value", Value: "Create" },
        { Id: 571225, PropertyName: "value", Value: "Edit" },
        { Id: 240857, PropertyName: "value", Value: "Delete" },
        { Id: 292855, PropertyName: "value", Value: "Ürünler" },
        { Id: 484823, PropertyName: "value", Value: "Müşteriler" },
        { Id: 858034, PropertyName: "value", Value: "Kullanıcılar" },
        { Id: 955945, PropertyName: "value", Value: "Kullanıcı Grupları" },
        { Id: 895401, PropertyName: "value", Value: "İstasyonlar" },
        { Id: 262135, PropertyName: "value", Value: "KLT Kutular" },
        { Id: 577355, PropertyName: "value", Value: "Siparişler" },
        { Id: 941805, PropertyName: "value", Value: "Teslim Tesellüm" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdusergroups_form_156069_value_kuikaTextInputRef = React.createRef();
    this.stdusergroups_form_109350_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      SaveRecord_1: 0,
      GoBack: "",
      SelectSTDUserGroups: [],
      GetGroupDetail: [],
      STDGetAllUserGroupsById: [],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stdusergroups_form", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.STDUserGroups_FormPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stdusergroups_form", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stdusergroups_form", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDUserGroups_FormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      stdusergroups_form_156069_value:
        this.state.GetGroupDetail?.at?.(0)?.groupName ?? undefined,
      stdusergroups_form_109350_value:
        this.state.GetGroupDetail?.at?.(0)?.groupDesc ?? undefined,
      stdusergroups_form_78375_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.productsView ?? undefined,
      stdusergroups_form_577394_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.productsCreate ??
        undefined,
      stdusergroups_form_452288_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.productsEdit ?? undefined,
      stdusergroups_form_756939_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.productsDelete ??
        undefined,
      stdusergroups_form_354830_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.customerView ?? undefined,
      stdusergroups_form_485970_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.customerCreate ??
        undefined,
      stdusergroups_form_444721_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.customerEdit ?? undefined,
      stdusergroups_form_6556_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.customerDelete ??
        undefined,
      stdusergroups_form_272513_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.usersView ?? undefined,
      stdusergroups_form_680690_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.usersCreate ?? undefined,
      stdusergroups_form_813684_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.usersEdit ?? undefined,
      stdusergroups_form_411398_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.usersDelete ?? undefined,
      stdusergroups_form_946569_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.userGroupView ?? undefined,
      stdusergroups_form_262605_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.userGroupCreate ??
        undefined,
      stdusergroups_form_459117_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.userGroupEdit ?? undefined,
      stdusergroups_form_957968_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.userGroupDelete ??
        undefined,
      stdusergroups_form_573988_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.stationsView ?? undefined,
      stdusergroups_form_145428_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.stationsCreate ??
        undefined,
      stdusergroups_form_787634_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.stationsEdit ?? undefined,
      stdusergroups_form_588393_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.stationsDelete ??
        undefined,
      stdusergroups_form_673374_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.boxView ?? undefined,
      stdusergroups_form_291302_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.boxCreate ?? undefined,
      stdusergroups_form_860884_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.boxEdit ?? undefined,
      stdusergroups_form_854829_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.boxDelete ?? undefined,
      stdusergroups_form_826267_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.orderView ?? undefined,
      stdusergroups_form_139768_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.orderCreate ?? undefined,
      stdusergroups_form_567582_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.orderEdit ?? undefined,
      stdusergroups_form_919936_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.orderDelete ?? undefined,
      stdusergroups_form_735025_checked:
        this.state.STDGetAllUserGroupsById?.at?.(0)?.teslimTesellumView ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  STDUserGroups_FormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDUserGroups_Form/STDUserGroups_FormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectSTDUserGroups = result?.data.selectSTDUserGroups;
    stateVars.GetGroupDetail = result?.data.getGroupDetail;
    formVars.stdusergroups_form_156069_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetGroupDetail !== undefined
        ? stateVars.GetGroupDetail?.length > 0
          ? stateVars.GetGroupDetail[0].groupName
          : null
        : this.state.GetGroupDetail?.length > 0
        ? this.state.GetGroupDetail[0].groupName
        : null
    );
    formVars.stdusergroups_form_109350_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetGroupDetail !== undefined
        ? stateVars.GetGroupDetail?.length > 0
          ? stateVars.GetGroupDetail[0].groupDesc
          : null
        : this.state.GetGroupDetail?.length > 0
        ? this.state.GetGroupDetail[0].groupDesc
        : null
    );
    stateVars.STDGetAllUserGroupsById = result?.data.stdGetAllUserGroupsById;
    formVars.stdusergroups_form_78375_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].productsView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].productsView
        : null
    );
    formVars.stdusergroups_form_577394_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].productsCreate
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].productsCreate
        : null
    );
    formVars.stdusergroups_form_452288_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].productsEdit
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].productsEdit
        : null
    );
    formVars.stdusergroups_form_756939_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].productsDelete
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].productsDelete
        : null
    );
    formVars.stdusergroups_form_354830_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].customerView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].customerView
        : null
    );
    formVars.stdusergroups_form_485970_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].customerCreate
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].customerCreate
        : null
    );
    formVars.stdusergroups_form_444721_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].customerEdit
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].customerEdit
        : null
    );
    formVars.stdusergroups_form_6556_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].customerDelete
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].customerDelete
        : null
    );
    formVars.stdusergroups_form_272513_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].usersView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].usersView
        : null
    );
    formVars.stdusergroups_form_680690_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].usersCreate
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].usersCreate
        : null
    );
    formVars.stdusergroups_form_813684_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].usersEdit
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].usersEdit
        : null
    );
    formVars.stdusergroups_form_411398_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].usersDelete
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].usersDelete
        : null
    );
    formVars.stdusergroups_form_946569_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].userGroupView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].userGroupView
        : null
    );
    formVars.stdusergroups_form_262605_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].userGroupCreate
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].userGroupCreate
        : null
    );
    formVars.stdusergroups_form_459117_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].userGroupEdit
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].userGroupEdit
        : null
    );
    formVars.stdusergroups_form_957968_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].userGroupDelete
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].userGroupDelete
        : null
    );
    formVars.stdusergroups_form_573988_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].stationsView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].stationsView
        : null
    );
    formVars.stdusergroups_form_145428_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].stationsCreate
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].stationsCreate
        : null
    );
    formVars.stdusergroups_form_787634_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].stationsEdit
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].stationsEdit
        : null
    );
    formVars.stdusergroups_form_588393_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].stationsDelete
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].stationsDelete
        : null
    );
    formVars.stdusergroups_form_673374_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].boxView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].boxView
        : null
    );
    formVars.stdusergroups_form_291302_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].boxCreate
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].boxCreate
        : null
    );
    formVars.stdusergroups_form_860884_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].boxEdit
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].boxEdit
        : null
    );
    formVars.stdusergroups_form_854829_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].boxDelete
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].boxDelete
        : null
    );
    formVars.stdusergroups_form_826267_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].orderView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].orderView
        : null
    );
    formVars.stdusergroups_form_139768_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].orderCreate
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].orderCreate
        : null
    );
    formVars.stdusergroups_form_567582_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].orderEdit
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].orderEdit
        : null
    );
    formVars.stdusergroups_form_919936_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].orderDelete
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].orderDelete
        : null
    );
    formVars.stdusergroups_form_735025_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].teslimTesellumView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].teslimTesellumView
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDUserGroups_FormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDUserGroups_FormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdusergroups_form_156069_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetGroupDetail !== undefined
        ? stateVars.GetGroupDetail?.length > 0
          ? stateVars.GetGroupDetail[0].groupName
          : null
        : this.state.GetGroupDetail?.length > 0
        ? this.state.GetGroupDetail[0].groupName
        : null
    );

    formVars.stdusergroups_form_109350_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetGroupDetail !== undefined
        ? stateVars.GetGroupDetail?.length > 0
          ? stateVars.GetGroupDetail[0].groupDesc
          : null
        : this.state.GetGroupDetail?.length > 0
        ? this.state.GetGroupDetail[0].groupDesc
        : null
    );

    formVars.stdusergroups_form_78375_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].productsView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].productsView
        : null
    );

    formVars.stdusergroups_form_577394_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].productsCreate
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].productsCreate
        : null
    );

    formVars.stdusergroups_form_452288_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].productsEdit
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].productsEdit
        : null
    );

    formVars.stdusergroups_form_756939_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].productsDelete
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].productsDelete
        : null
    );

    formVars.stdusergroups_form_354830_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].customerView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].customerView
        : null
    );

    formVars.stdusergroups_form_485970_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].customerCreate
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].customerCreate
        : null
    );

    formVars.stdusergroups_form_444721_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].customerEdit
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].customerEdit
        : null
    );

    formVars.stdusergroups_form_6556_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].customerDelete
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].customerDelete
        : null
    );

    formVars.stdusergroups_form_272513_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].usersView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].usersView
        : null
    );

    formVars.stdusergroups_form_680690_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].usersCreate
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].usersCreate
        : null
    );

    formVars.stdusergroups_form_813684_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].usersEdit
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].usersEdit
        : null
    );

    formVars.stdusergroups_form_411398_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].usersDelete
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].usersDelete
        : null
    );

    formVars.stdusergroups_form_946569_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].userGroupView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].userGroupView
        : null
    );

    formVars.stdusergroups_form_262605_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].userGroupCreate
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].userGroupCreate
        : null
    );

    formVars.stdusergroups_form_459117_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].userGroupEdit
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].userGroupEdit
        : null
    );

    formVars.stdusergroups_form_957968_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].userGroupDelete
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].userGroupDelete
        : null
    );

    formVars.stdusergroups_form_573988_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].stationsView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].stationsView
        : null
    );

    formVars.stdusergroups_form_145428_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].stationsCreate
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].stationsCreate
        : null
    );

    formVars.stdusergroups_form_787634_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].stationsEdit
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].stationsEdit
        : null
    );

    formVars.stdusergroups_form_588393_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].stationsDelete
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].stationsDelete
        : null
    );

    formVars.stdusergroups_form_673374_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].boxView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].boxView
        : null
    );

    formVars.stdusergroups_form_291302_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].boxCreate
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].boxCreate
        : null
    );

    formVars.stdusergroups_form_860884_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].boxEdit
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].boxEdit
        : null
    );

    formVars.stdusergroups_form_854829_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].boxDelete
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].boxDelete
        : null
    );

    formVars.stdusergroups_form_826267_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].orderView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].orderView
        : null
    );

    formVars.stdusergroups_form_139768_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].orderCreate
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].orderCreate
        : null
    );

    formVars.stdusergroups_form_567582_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].orderEdit
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].orderEdit
        : null
    );

    formVars.stdusergroups_form_919936_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].orderDelete
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].orderDelete
        : null
    );

    formVars.stdusergroups_form_735025_checked = ReactSystemFunctions.value(
      this,
      stateVars.STDGetAllUserGroupsById !== undefined
        ? stateVars.STDGetAllUserGroupsById?.length > 0
          ? stateVars.STDGetAllUserGroupsById[0].teslimTesellumView
          : null
        : this.state.STDGetAllUserGroupsById?.length > 0
        ? this.state.STDGetAllUserGroupsById[0].teslimTesellumView
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDUserGroups_FormComponent_9544_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdusergroups_form_109350_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdusergroups_form_109350_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdusergroups_form_156069_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdusergroups_form_156069_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      CustomerCreate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_485970_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      CustomerDelete_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_6556_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      CustomerEdit_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_444721_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      CustomerView_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_354830_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      GroupDesc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_109350_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      GroupName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_156069_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ProductsCreate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_577394_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      ProductsDelete_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_756939_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      ProductsEdit_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_756939_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      ProductsView_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_78375_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      UsersCreate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_680690_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      UsersDelete_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_411398_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      UsersView_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_272513_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      BoxCreate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_291302_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      BoxDelete_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_854829_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      BoxEdit_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_860884_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      BoxView_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_673374_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      OrderCreate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_139768_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      OrderDelete_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_919936_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      OrderEdit_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_567582_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      OrderView_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_826267_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      StationsCreate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_145428_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      StationsDelete_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_588393_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      StationsEdit_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_787634_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      StationsView_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_573988_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      TeslimTesellumView_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_735025_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      UserGroupDelete_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_957968_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      UserGroupCreate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_262605_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      UserGroupEdit_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_459117_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      UserGroupView_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_946569_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      UsersEdit_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdusergroups_form_813684_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDUserGroups_Form/STDUserGroups_FormComponent_9544_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveRecord_1 = result?.data.saveRecord_1;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDUserGroups_FormComponent_9544_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDUserGroups_FormComponent_9544_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDUserGroups_FormComponent_824675_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
